export const getRelativeTime = (date) => {
  const now = new Date();
  const then = new Date(parseInt(date));
  const diff = now - then;

  const sec = 1000;
  const min = sec * 60;
  const hou = min * 60;
  const day = hou * 24;
  const mon = day * new Date(then.getFullYear(), then.getMonth(), 0).getDate();

  if (diff < sec * 2) {
    return 'now';
  } else if (diff < min) {
    return Math.floor(diff / sec) + 's';
  } else if (diff < hou) {
    return Math.floor(diff / min) + 'm';
  } else if (diff < day) {
    return Math.floor(diff / hou) + 'h';
  } else if (diff < mon) {
    return Math.floor(diff / day) + 'd';
  } else if (diff > mon) {
    const month = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ][then.getMonth()];

    if (then.getFullYear() === now.getFullYear()) {
      return `${month} ${then.getDate()}`;
    } else {
      return `${month} ${then.getDate()}, ${then.getFullYear()}`;
    }
  }
};
